export const paymentOperationMessages = {
  en: { operations: {
    title: 'Payment progress', collapse: 'Collapse', expand: 'Details', close: 'Dismiss',
    hide: 'Hide notification', hideError: 'Could not hide the notification. Please try again.',
    received: 'Payment received. The exchange is queued or in progress. Flows are not yet confirmed.',
    waiting: 'Processing is taking longer. We are still checking the result. Please contact support if you need help.',
    purchase: 'The exchange is complete. Check the purchase result for each flow below.',
    prepaid: 'Flow prepayment is confirmed.', activated: 'Flows are activated.',
    error: 'Could not refresh the status. We will retry automatically.',
  } },
  ru: { operations: {
    title: 'Статус оплаты', collapse: 'Свернуть', expand: 'Подробнее', close: 'Закрыть',
    hide: 'Скрыть уведомление', hideError: 'Не удалось скрыть уведомление. Попробуйте ещё раз.',
    received: 'Оплата получена. Обмен в очереди или уже выполняется. Покупка потоков пока не подтверждена.',
    waiting: 'Обработка занимает больше времени. Мы продолжаем проверять результат. Если нужна помощь, обратитесь в поддержку.',
    purchase: 'Обмен завершён. Результат покупки каждого потока указан ниже.',
    prepaid: 'Предоплата потоков подтверждена.', activated: 'Потоки активированы.',
    error: 'Не удалось обновить статус. Попробуем ещё раз автоматически.',
  } },
}
